import React from 'react';
import { AlertTriangle, ShieldCheck } from 'lucide-react';

export default function NoTradeBanner({ noTrade, reason, failed, testId = 'no-trade-banner' }) {
  if (noTrade === undefined || noTrade === null) return null;
  const active = !!noTrade;
  return (
    <div
      data-testid={testId}
      className={`relative px-4 py-2 border flex items-center gap-3 text-[12px] font-mono ${
        active
          ? 'border-sell text-sell no-trade-glow'
          : 'border-buy text-buy'
      }`}
      style={{ background: active ? 'rgba(255,0,60,0.05)' : 'rgba(0,255,65,0.05)' }}
    >
      {active ? <AlertTriangle size={16} /> : <ShieldCheck size={16} />}
      <div className="font-display tracking-[0.3em] uppercase text-[11px]">
        {active ? 'no-trade mode // firewall engaged' : 'trade conditions clear'}
      </div>
      <div className="text-[var(--txt-secondary)]">—</div>
      <div className="text-[var(--txt-primary)] truncate">{reason}</div>
      {typeof failed === 'number' && (
        <div className="ml-auto text-[10px] text-[var(--txt-secondary)]">
          checks failed: <span className={active ? 'text-sell' : 'text-buy'}>{failed}</span>
        </div>
      )}
    </div>
  );
}
